import "@zenlayer/zen-design/esm/notification/style";
import _notification from "@zenlayer/zen-design/esm/notification";
import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
var _excluded = ["fileName"];
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { exportFile, readBlobJSONData, zenFetch } from '@zenlayer/util';
export function onExport(_x, _x2) {
  return _onExport.apply(this, arguments);
}

function _onExport() {
  _onExport = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref, request) {
    var fileName, props, _props$method, res, success, _res$headers, _res$headers$content, _res$headers$content$, _res$data, _success;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            fileName = _ref.fileName, props = _objectWithoutProperties(_ref, _excluded);
            _context.prev = 1;
            _context.next = 4;
            return (request !== null && request !== void 0 ? request : zenFetch.request)(_objectSpread(_objectSpread({}, props), {}, {
              method: (_props$method = props.method) !== null && _props$method !== void 0 ? _props$method : 'POST',
              responseType: 'blob'
            }));

          case 4:
            res = _context.sent;
            success = res.status === 200;

            if (success) {
              exportFile(fileName || ((_res$headers = res.headers) === null || _res$headers === void 0 ? void 0 : (_res$headers$content = _res$headers['content-disposition']) === null || _res$headers$content === void 0 ? void 0 : (_res$headers$content$ = _res$headers$content.split('=')) === null || _res$headers$content$ === void 0 ? void 0 : _res$headers$content$[1]), res.data);
            } else {
              _notification.error({
                description: (_res$data = res.data) === null || _res$data === void 0 ? void 0 : _res$data.msg
              });
            }

            return _context.abrupt("return", success);

          case 10:
            _context.prev = 10;
            _context.t0 = _context["catch"](1);
            readBlobJSONData(_context.t0.response.data).then(function (data) {
              _notification.error({
                description: data === null || data === void 0 ? void 0 : data.msg
              });
            });
            _success = false;
            return _context.abrupt("return", _success);

          case 15:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[1, 10]]);
  }));
  return _onExport.apply(this, arguments);
}